<template>
	<div class="field field--submit">
		<div class="field__element-wrap">
			<theme-btn  :name="name" type="submit" :disabled="disabled" ref="fieldElement" :parts="parts" v-on="$listeners">
				<slot></slot>
			</theme-btn>
		</div>
	</div>
</template>

<script>
import Btn from '../atoms/Btn'
import ThemeBtn from '../atoms/ThemeBtn'

export default {
	name: 'SubmitField',
	components: {
		Btn,
		ThemeBtn
	},
	props: {
		name: String,
		disabled: String,
		parts: Array
	},
	computed: {
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	.field--submit .field__element
	{
		@include extend(btn--style--fill)
	}

</style>



// WEBPACK FOOTER //
// src/components/atoms/SubmitField.vue